import client from './client';

// 로그인
export const login = ({ userId, userPw }) => 
  client.post('/auth/login', { userId, userPw });

// 로그인 상태 확인
export const check = () => client.get('/auth/check');
